import type { RailwayModel } from './types'

export const getFirstPendingLocation = (railways: RailwayModel[]) =>
  railways
    .filter(railway => railway.isPending)
    .flatMap(railway => railway.railwaySections)
    .filter(section => section.isPending)
    .flatMap(railwaySection => railwaySection.locations)
    .find(location => location.isPending)
